import { AppUrls } from '../../app/AppUrls';
import { Location } from '../../common/utils/Location';
import { ContentDefinitions } from '../models/contentDefinitions';
import { ContentTypeFilterValue, ContentTypeFilterAllOption } from '../models/ContentTypeFilterValue';
import * as queryString from 'query-string';
import { FilterTypes } from '../models/FilterTypes';
import { FilterAllOption } from '../state/FilterState';
import { SortBy, SortSelection } from '../models/SortSelection';
import { StringifyOptions } from 'query-string';

export class NavigationService {
  private urls!: AppUrls;
  public static instance = new NavigationService();

  public initialize(urls: AppUrls) {
    this.urls = urls;
  }

  public getUrlByContentType(contentTypeFilterValue: ContentTypeFilterValue, sort?: SortSelection) {
    const query = this.getQueryFromHashPath();
    const baseUrl =
      contentTypeFilterValue === ContentTypeFilterAllOption
        ? '#' + this.urls.searchPath()
        : '#' + ContentDefinitions[contentTypeFilterValue].getPath(this.urls);
    let url = query ? baseUrl + query : baseUrl;
    if (contentTypeFilterValue !== ContentTypeFilterAllOption && sort) {
      url = this.replaceOrAddSortOption(url, sort);
    } else if (contentTypeFilterValue === ContentTypeFilterAllOption) {
      url = this.removeQueryParams(url, 'order_by'); //use default when on mixed content page so remove the param
    }
    return url;
  }

  public navigateByContentType(contentTypeFilterValue: ContentTypeFilterValue, sort?: SortSelection) {
    const url = this.getUrlByContentType(contentTypeFilterValue, sort);
    Location.setUrl(url);
  }

  public navigateByFilter(filterType: FilterTypes, filterValue: string) {
    const baseUrl = Location.hash();
    const url =
      filterValue === FilterAllOption
        ? this.removeQueryParams(baseUrl, filterType)
        : this.replaceOrAddQueryParams(baseUrl, filterType, filterValue);
    Location.setUrl(url);
  }

  public clearFilter() {
    //this will remove all filters including the content type
    const baseUrl = this.getUrlByContentType(ContentTypeFilterAllOption);
    const url = Object.keys(FilterTypes).reduce((p, c) => (p = this.removeQueryParams(p, c)), baseUrl);
    Location.setUrl(url);
  }

  public navigateBySortOption(sort: SortSelection = SortBy.getRelevancySortSelection()) {
    const baseUrl = Location.hash();
    const url = this.replaceOrAddSortOption(baseUrl, sort);
    Location.setUrl(url);
  }

  private replaceOrAddSortOption(url: string, sort: SortSelection) {
    const order = encodeURI(`${sort.name}:${sort.primarySortDirection}`);
    const val = this.replaceOrAddQueryParams(url, 'order_by', order);
    return val;
  }

  private replaceOrAddQueryParams(url: string, filterType: string, filterValue: string) {
    const query = url.split('?')[1];
    if (query) {
      const parsedQuery = queryString.parse(query);
      parsedQuery[filterType] = encodeURIComponent(filterValue);
      const baseUrl = url.split('?')[0];
      return `${baseUrl}?${queryString.stringify(parsedQuery, { encode: false } as StringifyOptions)}`;
    } else {
      return url;
    }
  }

  private removeQueryParams(url: string, filterType: string) {
    const query = url.split('?')[1];
    if (query) {
      const parsedQuery = queryString.parse(query);
      delete parsedQuery[filterType];
      const baseUrl = url.split('?')[0];
      return `${baseUrl}?${queryString.stringify(parsedQuery, { encode: false } as StringifyOptions)}`;
    } else {
      return url;
    }
  }

  public getQueryFromHashPath() {
    const values = Location.hash().split('?');
    return values.length === 2 ? `?${values[1]}` : '';
  }
}
